export default class VoyageArrivalWindowData {
    constructor(id, earliestEta, latestEta, enforce) {
        this.id = id
        this.earliestEta = earliestEta
        this.latestEta = latestEta
        this.enforce = enforce
    }
}